(function () {
  if (window.__rfInit) return; window.__rfInit = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('rf-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.rf-reveal').forEach(function (el) { io.observe(el); });
})();
